import * as THREE from 'three';
import { G, M, TINT, HP, K_BEV, glowMat, mesh, bevel, rib, mergeBones, stages, boneG } from './kit';
/* ============================================================
   AUGENWALD 眼林 —— BOSS・複合十二眼
   ============================================================

   剪影：幹上長十二顆眼
   階段：'P1 全開・沒有背面','P2 收成花苞・無敵但也不攻擊','P3 爆開成水平眼環・全部朝你'

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-17 AUGENWALD 眼林 ── 複合式：一根 9 單位的幹，長 12 顆各自獨立的眼。
   P1 眼全開、朝四面八方 —— 沒有背面，繞後沒用。
   P2 眼收合成花苞，幹整個變成一根柱：無敵，但也不攻擊，這段是它在充能。
   P3 花苞爆開成一圈水平的眼環，同時全部朝你 —— 這是它的最後一招，也是弱點全露的時候。 */
var AWN = 12;
export function buildAugenwald(){
  var GLV = glowMat(TINT.vio.hex, 2.3), GLA = glowMat(TINT.amb.hex, 2.3);
  var root = new THREE.Group(), eyes = [], i;
  var trunk = boneG(root, 0, 0.70, 0);
  trunk.add(bevel(M.dark,  2.60, 1.40, 2.60, [0,0,0]));
  for (i = 0; i < 4; i++){
    var b = i*Math.PI * 2/4 + 0.78;
    trunk.add(mesh(G.cone, M.armor, [0.80,2.20,0.80],
      [Math.sin(b)*1.60, -0.30, Math.cos(b)*1.60], [0.42*Math.cos(b),0,-0.42*Math.sin(b)]));
  }
  var t2 = boneG(trunk, 0, 0.70, 0);
  t2.add(mesh(G.bev, M.armor, [1.80*K_BEV,4.40,1.80*K_BEV], [0, 2.20, 0]));
  t2.add(rib (M.armor, 0.14, 4.00, 0.14, [0, 2.20, 0.92]));
  t2.add(mesh(G.tor, M.trim, [2.20,2.20,0.44], [0, 4.30, 0], [HP,0,0]));
  var crown = boneG(t2, 0, 4.40, 0);
  for (i = 0; i < AWN; i++){
    var a = i*Math.PI * 2/AWN;
    var st = boneG(crown, 0, 0, 0); st.rotation.y = a;
    st.add(mesh(G.cyl, M.armor, [0.26,2.30,0.26], [0, 1.10, 0.30], [-0.26,0,0]));
    st.add(mesh(G.tor, M.trim,  [1.00,1.00,0.50], [0, 2.20, 0.60], [-0.26,0,0]));
    var em = mesh(G.oct, i % 2 ? GLV : GLA, [0.80,0.80,0.80], [0, 2.24, 0.62]);
    em.userData.noMerge = 1; st.add(em); st.userData.em = em;
    eyes.push(st);
  }
  root.userData.rig = {trunk:trunk, t2:t2, crown:crown, eyes:eyes, GLV:GLV, GLA:GLA};
  return mergeBones(root);
}
export function updAugenwald(rig, o, dt){
  stages(rig, o, dt, 1.7);
  var s1 = rig.s1, s2 = rig.s2, i;
  var bud = s1*(1-s2);                              // 只有二階段是花苞
  rig.crown.rotation.y += dt*(0.35 + 2.2*bud + 1.1*s2);
  rig.crown.position.y = 4.40 - 0.60*bud + 0.30*s2;
  rig.t2.rotation.x = 0.03*Math.sin(o.t*0.8) - o.tel*0.06;
  for (i = 0; i < AWN; i++){
    var st = rig.eyes[i];
    /* 張開 −0.26 → 花苞 −1.30（全部朝上收攏）→ 平展 +1.15（水平眼環） */
    st.rotation.x = -1.04*bud + 1.41*s2 + 0.10*Math.sin(o.t*1.6 + i);
    st.scale.setScalar(1 - 0.22*bud + 0.30*s2);
    st.userData.em.scale.setScalar(
      (0.45 + 0.55*(1-bud))*(1 + 0.22*Math.sin(o.t*3.2 + i*1.7) + 1.1*o.tel + 0.6*s2));
  }
  rig.trunk.position.y = 0.70 + 0.06*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
  rig.GLV.emissiveIntensity = 2.3*(1-0.75*bud) + 2.6*o.tel + 2.0*s2;
  rig.GLA.emissiveIntensity = 2.3*(1-0.75*bud) + 2.6*o.tel + 2.0*s2;
}